import { FC } from "react";
import { getColorFromLetter } from "../../../common/Color";
import styles from "./ProjectCard.module.less";

interface VendorLogoProps {
    vendorHero?: string;
    vendorName?: string;
    projectName?: string;
}

/**
 * What stands in for a missing vendor logo: the vendor's initial, or the
 * project's, on a color derived from it. Shared by the project page header
 * and the hub's project list.
 */
export const projectLogoFallback = (
    vendorName?: string,
    projectName?: string
): { letter: string; color: string } => {
    const letter = ((vendorName || projectName || "P").charAt(0)).toUpperCase();
    return { letter, color: getColorFromLetter(letter) };
};

export const VendorLogo: FC<VendorLogoProps> = ({ vendorHero, vendorName, projectName }) => {
    const { letter: fallbackLetter, color: fallbackColor } = projectLogoFallback(
        vendorName,
        projectName
    );

    return (
        <div className={styles.logo}>
            {vendorHero ? (
                <img src={vendorHero} alt={vendorName} />
            ) : (
                <div className={styles.logoFallback} style={{ backgroundColor: fallbackColor }}>
                    {fallbackLetter}
                </div>
            )}
        </div>
    );
};
